import firebase from './Firebase.js'  
export const databaseRef = firebase.database().ref();

// Database Node References
export const devicesRef = databaseRef.child("LastUpdatedDeviceUuid");
export const pharmaciesRef = databaseRef.child("Pharmacies");

export const deviceRef = databaseRef.child("LastUpdatedDeviceUuid").orderByChild('LatestSetupPharmacyId');
// export const pharmacyRef = databaseRef.child("Pharmacies").orderByChild('deviceUuid');
